import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PasswordRuleState} from 'app/core/auth/password-rules';

/**
 * The tenant's password requirements, each ticked off as the typed password satisfies it.
 * <p>
 * Standalone so the signed-out pages can pull it in without a shared module. Purely presentational:
 * the API remains the authority on whether a password is acceptable.
 */
@Component({
    selector: 'password-requirements',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ul *ngIf="rules?.length" class="password-requirements">
            <li *ngFor="let rule of rules" [class.met]="rule.met">
                <span class="marker" aria-hidden="true">{{ rule.met ? '✓' : '•' }}</span>
                <span>{{ rule.label }}</span>
            </li>
        </ul>
    `,
    styles: [
        `
            .password-requirements {
                list-style: none;
                margin: 4px 0 12px;
                padding: 0;
                font-size: 12px;
                line-height: 20px;
            }

            .password-requirements li {
                display: flex;
                align-items: center;
                color: rgba(0, 0, 0, 0.45);
            }

            .password-requirements li.met {
                color: #52c41a;
            }

            .password-requirements .marker {
                width: 16px;
                display: inline-block;
            }
        `
    ]
})
export class PasswordRequirementsComponent {
    /** Every requirement the tenant applies, with whether the current input meets it. */
    @Input() rules: PasswordRuleState[] = [];
}
